import { createFileRoute } from '@tanstack/react-router'
import { UserEditorPage } from '@/features/users/editor'

export const Route = createFileRoute('/users_/new')({
  component: UserEditorPage,
})
